import React from 'react';
//import '../../css/searchbar.css';
//import KeyBoardIcon from '../../images/keyboard.png';
import KeyBoardgrayIcon from '../../images/keyboardgray.png';
import {WordBookGroupBookChapter} from '../../../Classes/WordBookGroupBookChapter';
import Keyboard from '../modal/KeyBoard';
import Modal from 'react-bootstrap/Modal'

class SearchBar extends React.Component{
    
    state = { word: '' };
    state = { modalshow: false };
    state = {selectionStart : 0 };
    state = {selectionEnd : 0 };

    onSearchButtonClick =event =>{
        event.preventDefault();
        this.setState({modalshow:false});
        //console.log("OSBC:",this.state.word);
        if (this.state.word!=='' && this.state.word!==undefined)
        {
            var WGBC=new WordBookGroupBookChapter(  this.state.word.replaceAll('#','%23')
                                                                    .replaceAll('*','{Star}')
                                                                    .replaceAll('/','{Slash}')
                                                                    .replaceAll('<','%2C')
                                                                    .replaceAll('>','%2E')
                                                                    .replaceAll('\\','{BackSlash}')
                                                                    .trim()
                                                    ,this.props.SelectedBookGroup
                                                    ,this.props.SelectedBook
                                                    ,this.props.SelectedChapter);
            //console.log("WGBC:",WGBC.Word+'/'+WGBC.BookGroup+'/'+WGBC.Book+'/'+WGBC.Chapter);
            this.props.onSearchButtonClick(WGBC);
        }
    }

    onKeyboardButtonClick = event =>{
        event.preventDefault();
        //console.log("KeyboardButtonPressed:",event.target.id);
        //console.log("S3:",this.state.selectionStart);
        //console.log("E3:",this.state.selectionEnd );
        window.location.href="#Head";
        if (!this.state.selectionStart)
        {
            this.setState({selectionStart : event.target.selectionStart});
            this.setState({selectionEnd : event.target.selectionStart});
        }
        this.setState({modalshow:!this.state.modalshow});
    }

    onTextChange = event=> {
        this.setState({word:event.target.value})
        if (!this.state.modalshow)
        {
            this.setState({selectionStart : event.target.selectionStart});
            this.setState({selectionEnd : event.target.selectionEnd});
        }
    }

    onTextKeyPress = event => {
        //console.log("OSBC:",event.nativeEvent.key);
        if ((event.nativeEvent.key === "Enter")&&(this.state.word)) {
            event.preventDefault();
            this.onSearchButtonClick(event);
        }
        this.setState({selectionStart : event.target.selectionStart});
        this.setState({selectionEnd : event.target.selectionEnd});
        //console.log("S2:",this.state.selectionStart);
        //console.log("E2:",this.state.selectionEnd);
    }

    onTextClick = event =>{
        this.setState({modalshow:false})
        this.setState({selectionStart : event.target.selectionStart});
        this.setState({selectionEnd : event.target.selectionEnd});
        //console.log("S:",event.target.selectionStart);
        //console.log("E:",event.target.selectionEnd );
    }

    onVirtualKeyBoardTyped = input =>{
        const inputed=  (
                            ((this.state.word)&&(this.state.word.length>0))
                            ?
                            this.state.word.substring(0,this.state.selectionStart)
                            + input
                            + this.state.word.substring(this.state.selectionEnd,this.state.word.length)
                            :
                            input
                        )   
        this.setState({selectionStart : this.state.selectionStart+input.length});
        this.setState({selectionEnd : this.state.selectionStart});
        //console.log("S1:",this.state.selectionStart);
        //console.log("E1:",this.state.selectionEnd);
        this.setState({word:inputed});
    }

    render(){
        return (
            <div className="SearchBar" style={{margin:'0px auto 0px auto',width:'100%'}}>
                <form>
                    <div className="divSearch">
                        <input 
                            id="word" 
                            type="text" 
                            className={this.state.word?this.props.ShowInClass:"farsi"}
                            placeholder={this.props.PlaceHolder}
                            required="required" 
                            value={this.state.word || ''} 
                            onChange={this.onTextChange}
                            onKeyPress={this.onTextKeyPress}
                            onClick={this.onTextClick}
                            dir={(this.props.ShowInClass==="farsi" || this.props.ShowInClass==="Pahlavi")?"rtl":"ltr"}
                            autoComplete="off"
                        />
                        <input className="keyboard" type="image" alt="KB" src={KeyBoardgrayIcon} onClick={this.onKeyboardButtonClick} />
                    </div>
                    <div className="fullwidth_div">
                        <Modal
                            show={this.state.modalshow}
                            onHide={() => this.setState({modalshow: false})}
                            dialogClassName="modal-content-KB"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Body>
                                <Keyboard input={this.state.word} layout={this.props.ShowInClass} onVirtualKeyBoardTyped={this.onVirtualKeyBoardTyped}/>
                            </Modal.Body>
                        </Modal>
                        <input className="submit_button" type="submit" value={this.props.pageData.length!==0 && this.props.pageData[0].F29901!== undefined?this.props.pageData[0].F29901:29901/*"جستجو"*/} onClick={this.onSearchButtonClick} />
                    </div>
                </form>
            </div>
        );
    }
}

export default SearchBar;